import { Region } from '../Constants';
export function getRegionalPathname(region) {
    return `/${region.toLowerCase()}/`;
}
export function isRegionalURL(url) {
    return Object.values(Region).some((region) => {
        return url.pathname === getRegionalPathname(region);
    });
}
//# sourceMappingURL=URL.js.map